import * as React from 'react'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './style.scss'

interface IProps {
  label: string
  input: any
  type?: string
  onChangeMaskedInput: any
  initialValue?: string
  meta?: any
}

interface IState {
  textMask: string
  phone: string
}

export class MaskedInput extends React.Component<IProps, IState> {
  state = {
    textMask: ' (   )    -    ',
    phone: ''
  }

  handleChange = value => {
    const phoneNumber = value.target.value
    this.setState({ phone: phoneNumber })
    this.props.onChangeMaskedInput(phoneNumber)
  }

  componentDidMount() {
    const { initialValue } = this.props
    if (initialValue) {
      this.setState({ phone: initialValue })
      this.props.onChangeMaskedInput(initialValue)
    }
  }

  render() {
    const {
      input,
      label,
      meta: { invalid, error, dirty }
    } = this.props
    let { type } = this.props

    if (!type) {
      type = 'text'
    }

    return (
      <FormControl className="input-form-control masked-input">
        {/* <InputLabel variant='filled'  filled={true} htmlFor={`${input.name}-field`}>{label}</InputLabel> */}
        <div className="label">{label}</div>
        <ReactPhoneInput
          defaultCountry="us"
          autoFormat={true}
          containerStyle={{ width: '100%' }}
          inputStyle={{
            width: '100%',
            background: 'transparent',
            border: '1px solid white',
            borderBottom: '1px solid #949494',
            borderRadius: 0
          }}
          buttonStyle={{
            width: '12%',
            background: 'transparent',
            borderRadius: 0,
            border: '1px solid white',
            borderBottom: '1px solid #949494'
          }}
          dropdownStyle={{
            textAlign: 'left'
          }}
          inputExtraProps={{
            name: 'phone',
            onChange: value => this.handleChange(value)
          }}
          value={this.state.phone}
        />
        {invalid && dirty && (
          <FormHelperText id={`${input.name}-field`} className="error-message">
            {error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MaskedInput/index.tsx